import { render, staticRenderFns } from "./ShareManagementattached.vue?vue&type=template&id=9990c480"
import script from "./ShareManagementattached.vue?vue&type=script&lang=js"
export * from "./ShareManagementattached.vue?vue&type=script&lang=js"
import style0 from "./ShareManagementattached.vue?vue&type=style&index=0&id=9990c480&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports